import cloneDeep from 'lodash/cloneDeep'

import {
  UPDATE_SEARCH,
  SEARCH_STATE,
  UPDATE_LAST_SUGGESTION,
  UPDATE_SEARCH_FROM_LOCAL_STORAGE,
} from './constants'
import stateBase from './state'
import { FETCH_LOCATION_SUCCESS } from 'client/contexts/Location/constants'
import { getSearchParamsLocalStorage } from 'lib/storage'

const initialState = stateBase[SEARCH_STATE]

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_FROM_LOCAL_STORAGE: {
      const payload = getSearchParamsLocalStorage()

      return {
        ...state,
        ...cloneDeep(payload),
        lastSuggestion: state.lastSuggestion?.id ? state.lastSuggestion : payload,
      }
    }
    case UPDATE_SEARCH:
      return {
        ...state,
        ...cloneDeep(action.payload),
        lastSuggestion: state.lastSuggestion?.id ? state.lastSuggestion : action.payload,
      }

    // Update latitude and longitude in the search state when user moves through the map
    // to avoid re-center the map when user changes the filters and refetch the properties
    case FETCH_LOCATION_SUCCESS:
      return {
        ...state,
        latitude: action.payload.latitude,
        longitude: action.payload.longitude,
      }

    case UPDATE_LAST_SUGGESTION:
      return {
        ...state,
        lastSuggestion: action.payload,
      }

    default:
      return state
  }
}

export default reducer
